import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { authService } from '../services';
import { Input, Button, Card } from '../components';
import { forgotPasswordSchema } from '../utils/validationSchemas';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [generalError, setGeneralError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(forgotPasswordSchema),
    defaultValues: {
      email: '',
    },
  });

  const onSubmit = async (data) => {
    setLoading(true);
    setGeneralError('');
    
    try {
      await authService.forgotPassword(data.email);
      
      // Mostrar mensaje de éxito
      setSuccess(true);
      
      // Redirigir a login después de 5 segundos
      setTimeout(() => {
        navigate('/login');
      }, 5000);
    } catch (error) {
      setGeneralError(error.response?.data?.message || 'Error al solicitar recuperación de contraseña');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password">
      <div className="forgot-password__container">
        <div className="forgot-password__header">
          <h1 className="forgot-password__title">PICHTRAINING</h1>
          <p className="forgot-password__subtitle">Recuperar Contraseña</p>
        </div>
        
        <Card>
          {success ? (
            <div className="forgot-password__success">
              <div className="forgot-password__success-icon">✓</div>
              <h2>Email enviado</h2>
              <p>Revisa tu email para las instrucciones de recuperación de contraseña.</p>
              <p className="forgot-password__redirect">Redirigiendo a login...</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)} className="forgot-password__form">
              <p className="forgot-password__description">
                Ingresa tu email y te enviaremos un enlace para resetear tu contraseña.
              </p>
              
              {generalError && (
                <div className="forgot-password__error-banner">
                  {generalError}
                </div>
              )}
              
              <Input
                label="Email"
                type="email"
                {...register('email')}
                placeholder="tu@email.com"
                error={errors.email?.message}
                required
              />
              
              <Button
                type="submit"
                variant="primary"
                fullWidth
                loading={loading}
              >
                Enviar Link de Recuperación
              </Button>
              
              <div className="forgot-password__footer">
                <Link to="/login" className="forgot-password__link">
                  Volver a Login
                </Link>
              </div>
            </form>
          )}
        </Card>
      </div>
    </div>
  );
};

export default ForgotPassword;
